import React from "react";
import { ArrowUp, ArrowDown } from "lucide-react";
import { HeatBadge } from "../../../components/players-to-watch";
import { PLAYER_HEADSHOT_FALLBACK } from "../../../config/constants";

export function PlayerCard({ player, playerType, headshotUrl, cutoff }) {
  const change = Number(player.woba_change) || 0;
  const isHot = playerType === "pitcher" ? change < 0 : change > 0;
  const deltaAbs = Math.abs(change).toFixed(3).replace(/^0\./, ".");

  return (
    <div
      className={`bg-white rounded-xl border-2 shadow-sm p-4 flex items-center gap-4 hover:shadow-md transition-shadow ${
        isHot ? "border-orange-200" : "border-slate-200"
      }`}
    >
      <img
        src={headshotUrl || PLAYER_HEADSHOT_FALLBACK}
        alt={player.player_name}
        className="w-16 h-16 rounded-full object-cover bg-gray-100 flex-shrink-0 ring-2 ring-white shadow"
        onError={(e) => { e.currentTarget.src = PLAYER_HEADSHOT_FALLBACK; }}
      />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1 flex-wrap">
          <a
            href={`/player/${player.player_id}`}
            className="font-bold text-gray-900 text-sm hover:text-blue-600 hover:underline"
          >
            {player.player_name}
          </a>
          <HeatBadge change={player.woba_change} playerType={playerType} cutoff={cutoff} />
        </div>
        <div className="flex items-center gap-4 text-xs mt-1">
          <div className="text-center">
            <div className="font-semibold text-gray-600">{player.woba_then}</div>
            <div className="text-gray-400 uppercase tracking-wide">Then</div>
          </div>
          <div className="text-gray-300">→</div>
          <div className="text-center">
            <div className="font-semibold text-gray-600">{player.woba_now}</div>
            <div className="text-gray-400 uppercase tracking-wide">Now</div>
          </div>
          <div
            className={`flex items-center font-bold text-sm ml-1 ${
              isHot ? "text-orange-500" : "text-slate-400"
            }`}
          >
            {isHot ? <ArrowUp size={14} className="mr-0.5" /> : <ArrowDown size={14} className="mr-0.5" />}
            {deltaAbs}
          </div>
        </div>
      </div>
    </div>
  );
}
